import React, { Component } from 'react'
import style from '../style.module.less'
import { Timeline, Button, Switch, Input } from 'hljd'
import { observer } from 'mobx-react'
import { isStoreAccount } from '@util'

const Item = Timeline.Item
const TextArea = Input.TextArea

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    const {
      history,
      message,
      detail: { status, is_come, operator, merchant_customer_id },
      isEdit,
      exp_saler
    } = store

    const _html = history.map((item, index) => (
      <Item color={index !== 0 ? '#aaaaaa' : '#508cee'} key={index}>
        <div>
          <p>
            <span style={{ color: '#999' }}>{item.created_at}</span>
            <span style={{ marginLeft: 9 }}>
              {
                {
                  '0': '未查看',
                  '1': '已查看',
                  '2': '已过期',
                  '3': '已查看',
                  '4': '跟进失败',
                  '5': '已成单',
                  '6': '已退单'
                }[item.status + '']
              }
            </span>
          </p>
          <p>{item.message}</p>
        </div>
      </Item>
    ))
    return (
      <div className={style.followUp_info}>
        <div className={style.order_status}>
          <h3>
            推荐单状态：{
              {
                '0': '未查看',
                '1': '已查看',
                '2': '已过期',
                '3': '已查看',
                '4': '跟进失败',
                '5': '已成单',
                '6': '已退单'
              }[status + '']
            }
          </h3>
          <div className={style.sale_info}>
            {isStoreAccount() &&
            merchant_customer_id &&
            merchant_customer_id !== '0' ? (
              <div className={style.left}>
                <span>最新操作人：</span>
                <span>{operator}</span>
              </div>
            ) : (
              <div className={style.left}>
                <span>对接销售：</span>
                {isEdit ? (
                  <span>
                    <Input
                      style={{ width: 80, marginRight: 8 }}
                      value={exp_saler}
                      onChange={store.changeField('exp_saler')}
                    />
                    <a onClick={store.saveSaler}>保存</a>
                  </span>
                ) : (
                  <span>
                    <span style={{ display: 'inline-block', MaxWidth: 80 }}>
                      {exp_saler}
                    </span>
                    <a onClick={store.editSaler} className={style.edit} />
                  </span>
                )}
              </div>
            )}

            <div className={style.right}>
              <span>已到店</span>
              <Switch
                style={{ verticalAlign: 'top' }}
                checked={is_come + '' === '1'}
                onChange={store.comeMerchant}
              />
            </div>
          </div>
          <div className={style.desc}>
            <p style={{ marginBottom: 15 }}>
              备注：<span style={{ float: 'right' }}>
                <i style={{ color: message.length > 480 && '#ff5c5c' }}>
                  {message.length}
                </i>/500
              </span>
            </p>
            <TextArea
              placeholder="请填写跟进备注"
              autoSize={{ minRows: 7, maxRows: 7 }}
              value={message}
              onChange={store.changeField('message')}
            />
          </div>
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <Button
              type="primary"
              style={{ marginRight: 15, width: 90 }}
              onClick={store.saveRemark}
            >
              提交
            </Button>
            {(status + '' === '1' || status + '' === '3') && (
              <Button
                type="primary"
                style={{ marginRight: 15, width: 90 }}
                onClick={store.orderForm}
              >
                确认成单
              </Button>
            )}
            {(status + '' === '1' || status + '' === '3') && (
              <Button style={{ width: 90 }} onClick={store.followFail}>
                跟进失败
              </Button>
            )}
          </div>
        </div>
        <div className={style.history}>
          <p className={style.title}>历史跟进记录</p>
          <div>
            {history.length > 0 ? (
              <Timeline>{_html}</Timeline>
            ) : (
              <div className={style.no_data} />
            )}
          </div>
        </div>
      </div>
    )
  }
}
